<template>
  <div class="slots-selection">
    <h2 class="my-5">Select Slot</h2>
    <div
      v-for="(date, index) in Object.keys(groupedSlots)"
      :key="index"
      class="d-flex flex-column"
    >
      <p class="font-weight-bold">{{ date | dayFormatLong }}</p>
      <RadioButton
        v-if="groupedSlots[date]"
        :options="groupedSlots[date]"
        :selectedValue="selectedSlot"
        @select="handleSelect"
        showGroupInRow
      />
    </div>
    <div v-if="showValidationErrors && !selectedSlot" class="text-error">
      This field is required
    </div>
  </div>
</template>

<script>
import RadioButton from "@/components/common/RadioButton";
import { formatDate } from "@/utils/time";
import { getSlotsGroupedByDate } from "@/views/bookings/BookingInterviews/modules/utils";
import {
  DATE_FORMAT_WITH_SEPARATOR_REVERSED,
  LONG_DATE_FORMAT
} from "@/constants/common.js";

export default {
  name: "GroupedSlotsSelection",
  components: {
    RadioButton
  },
  props: {
    showValidationErrors: Boolean,
    selectedSlot: Object,
    slots: Array
  },
  computed: {
    groupedSlots() {
      return getSlotsGroupedByDate(this.slots);
    }
  },
  methods: {
    handleSelect(val) {
      this.$emit("select", val);
    }
  },
  filters: {
    dayFormatLong(date) {
      return formatDate({
        date,
        startFormat: DATE_FORMAT_WITH_SEPARATOR_REVERSED,
        endFormat: LONG_DATE_FORMAT
      });
    }
  }
};
</script>

<style lang="scss">
.slots-selection {
  .radio {
    @include interview-radio;

    .v-input--radio-group__input {
      justify-content: flex-start;
    }
  }
}
</style>
